import _ from "lodash";
import React from "react";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import {createSelector} from "@reduxjs/toolkit";

import {selectFlat} from "@/data/select_flat.js";
import {PermissionCard} from "./permission_card.jsx";

export function PermissionsPane() {
  const intl = useIntl();

  const selectTranslatedPermissions = createSelector(
    selectFlat("permission"), ap => ap.map(p => {
      return {
        id: p.id,
        action: intl.formatMessage({id: "permissions.property.action." + p.action}),
        target: intl.formatMessage({id: "permissions.property.target." + p.target}),
        targetType: intl.formatMessage({id: "permissions.property.targetType." + p.targetType}),
        targetCreatedBy: intl.formatMessage({id: "permissions.property.targetCreatedBy." + p.targetCreatedBy}),
        targetOrganization: intl.formatMessage({id: "permissions.property.targetOrganization." + p.targetOrganization}),
        targetIdentifier: p.targetIdentifier ?? intl.formatMessage({id: "permissions.property.targetIdentifier.null"}),
        description: intl.formatMessage({id: "permissions.property.description." + [
          p.action, p.target, p.targetType, p.targetCreatedBy, p.targetOrganization
        ].filter(x => x).join(".") + ((p.targetIdentifier) ? ".identified" : "")}, {identifier: p.targetIdentifier})
      };
    })
  );
  const selectOrderedPermissions = createSelector(
    selectTranslatedPermissions, tp => _.orderBy(
      tp, ["target", "action", "targetType", "targetCreatedBy", "targetOrganization", "targetIdentifier"])
  );
  const permissions = useSelector(selectOrderedPermissions);

  return (
    <div className="permissions-pane pane focusable-collection">
      <div className="pane-top">
        <h1 className="permissions-title pane-title">
          {intl.formatMessage({id: "permissions.title"})}
        </h1>
      </div>
      <table className="permissions-table">
        <thead>
          <tr>
            <th>Action</th>
            <th>Target</th>
            <th>Type</th>
            <th>Creator</th>
            <th>Organization</th>
            <th>Identifier</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {permissions.map(permission => (
            <PermissionCard key={permission.id} permission={permission}/>
          ))}
        </tbody>
      </table>
    </div>
  );
}
